module.exports = {"620721100":"红湾寺镇","620721101":"皇城镇","620721102":"康乐镇","620721200":"马蹄藏族乡","620721202":"白银蒙古族乡","620721203":"大河乡","620721204":"明花乡","620721205":"祁丰蔵族乡","620721500":"甘肃省绵羊育种场","620721501":"张掖宝瓶河牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620721.json
// module id = 2919
// module chunks = 0